import React from 'react';
import { Link } from 'react-router-dom';

const GIFT_CATEGORIES = [
    { title: 'For Gamers', to: '/gifts/gamers', image: '/images/Mugs/Mario/pp6349nn_super_mario_warp_pipe_travel_mug_square_lifestyle_1.jpg' },
    { title: 'For Movie Buffs', to: '/gifts/movie-buffs', image: '/images/Poster/Jaws.jpg' },
    { title: 'For TV Fans', to: '/gifts/tv-fans', image: '/images/Poster/RickMorty3.jpg' },
    { title: 'For Superhero Fans', to: '/gifts/superhero', image: '/images/Lamps/Batman/batlight3.jpg' },
    { title: 'For Kids', to: '/gifts/kids', image: '/images/Toys/SonicStretch/mini-stretch-sonic-the-hedgehog-wholesale-67015.jpg' },
    { title: 'For Dad', to: '/gifts/dad', image: '/images/Homeware/Thor/thor2.jpg' },
    { title: 'For Retro Lovers', to: '/gifts/retro-lovers', image: '/images/Collectables/Heman/heman/heman4.jpg' },
    { title: 'Under £20', to: '/search?maxPrice=20', image: '/images/Mugs/Wolverine/pp13027xm_x-men_wolverine_shaped_mug_lifestyle_4_square.jpg' },
];

const GiftFinder = () => (
    <ul className="rd-gifts">
        {GIFT_CATEGORIES.map(({ title, to, image }) => (
            <li key={to}>
                <Link to={to}>
                    <img src={image} alt="" loading="lazy" />
                    <span>{title}</span>
                </Link>
            </li>
        ))}
    </ul>
);

export default GiftFinder;
